import { useCallback } from 'react';
import { addModule as addModuleAction } from '../redux/actions/layout';
import { useDispatch } from 'react-redux';
import usePrivileges from './usePrivileges';
import { ModuleName } from '../types/modules';
import { ZoneName } from '../types/zones';
import { useGruser } from './useGruser';

export const useLayoutActions = (): {
  canAddModule: boolean;
  addModule?: (moduleName: ModuleName, zoneName: ZoneName, position: number) => void;
} => {
  const { gruser } = useGruser();
  const dispatch = useDispatch();
  const { canAddModule } = usePrivileges();

  const dispatchAddModule = useCallback(
    (moduleName: ModuleName, zoneName: ZoneName, position: number) =>
      dispatch(addModuleAction(gruser!, { zoneName, moduleName, position })),
    [dispatch, gruser]
  );

  const addModule = canAddModule ? dispatchAddModule : undefined;

  return {
    canAddModule,
    addModule,
  };
};
